// Route-based sidenav matching. Keys like `pm-budget` never equal the first
// path segment (`procurement`), which is why procurement items stayed dim.

export const isPathActive = (pathname, route) => {
  if (!route || !pathname) return false
  if (pathname === route) return true
  return pathname.startsWith(`${route}/`)
}

// Sibling leaf routes can overlap as path prefixes (e.g. "/procurement/orders"
// and "/procurement/orders/groups"), which made isPathActive() light up both.
// Only the single most specific (longest) matching route among siblings
// should be marked active.
export const pickActiveRoute = (pathname, routeList = []) => {
  if (!pathname) return null
  let best = null
  for (const route of routeList) {
    if (!route) continue
    if (pathname === route) return route
    if (pathname.startsWith(`${route}/`) && (!best || route.length > best.length)) {
      best = route
    }
  }
  return best
}

export const isNavItemActive = (pathname, item) => {
  if (!item) return false
  const kids = (item.collapse || []).filter((c) => c && c.type !== "hidden")
  if (kids.some((child) => isNavItemActive(pathname, child))) return true
  return isPathActive(pathname, item.route)
}

export const findOpenCollapseKey = (pathname, routes = []) => {
  const match = (routes || []).find(
    (item) =>
      item &&
      item.type === "collapse" &&
      item.collapse &&
      item.collapse.length > 0 &&
      isNavItemActive(pathname, item)
  )
  return match?.key || false
}

export const findOpenNestedKey = (pathname, routes = []) => {
  for (const item of routes || []) {
    if (!item?.collapse) continue
    for (const child of item.collapse) {
      if (child?.collapse && isNavItemActive(pathname, child)) return child.key
    }
  }
  return false
}
